// Core
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

// Redux
import { useDispatch } from "react-redux";
import {
  checkLinkForCreatePasswordRequest,
  forgotPasswordRequest,
} from "../../../../Redux/Slices/Common/commonSlice";

// Styles
import "./styles.scss";

// Layouts
import AuthLayout from "../../../../Layouts/Auth";

// Utils
import { validatePasswords } from "../../../../Services/Utils/validateInput";
import { getDeviceId } from "../../../../Services/Utils/commonServices";

// Custom components
import InputBox from "../../../../Components/InputBox";
import Button from "../../../../Components/Button";
import ErrorMessage from "../../../../Components/ErrorMessage";

const CreatePassword = () => {
  //Initialize redux
  const dispatch = useDispatch();

  // Initialize useNavigate
  const navigate = useNavigate();

  //To get params
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const slug = queryParams.get("slug");

  //Core useEffect
  useEffect(() => {
    if (slug) {
      dispatch(
        checkLinkForCreatePasswordRequest({
          slug,
        })
      );
    }
  }, []);

  const userDetails = JSON.parse(localStorage?.getItem("userDetails"));

  // Initial state for form data and errors
  const initialFormData = { password: "", confirmPassword: "" };
  const initialErrors = {};

  // Local states
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState(initialErrors);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Update form data
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    // Clear error for the specific field
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  // Validate and handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validatePasswords(
      formData.password,
      formData.confirmPassword
    );

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      dispatch(
        forgotPasswordRequest({
          data: {
            new_password: formData?.password,
            confirm_password: formData?.confirmPassword,
            email: userDetails?.email,
            device_token: getDeviceId(),
          },
          callBack: forgotPasswordRequestCB,
        })
      );
    }
  };

  const forgotPasswordRequestCB = (data) => {
    localStorage?.setItem("isLoggedIn", null);
    navigate("/password-success", { replace: true });
    setFormData(initialFormData);
    setErrors(initialErrors);
  };

  const eye_icon = {
    position: "absolute",
    top: "50%",
    right: "17%",
    transform: "translateY(-50%)",
    cursor: "pointer",
  };

  return (
    <AuthLayout>
      <div className="user-create-password-root-container">
        <h1 className="user-create-password-heading">Create Password</h1>
        <p className="user-create-password-sub-heading">Create your Password</p>
        <hr className="user-create-password-hr" />
        <form onSubmit={handleSubmit}>
          <InputBox
            label="New Password"
            name="password"
            type="password"
            value={formData.password}
            onChange={handleChange}
            inputStyle={{ width: "85%" }}
            eyeIconStyle={eye_icon}
          />
          <ErrorMessage message={errors.password} />
          <div className="user-spacer" />
          <InputBox
            label="Confirm New Password"
            name="confirmPassword"
            type="password"
            value={formData.confirmPassword}
            onChange={handleChange}
            inputStyle={{ width: "85%" }}
            eyeIconStyle={eye_icon}
          />
          <ErrorMessage message={errors.confirmPassword} />
          <div className="user-create-password-footer">
            <Button title="Continue" buttonStyle={{ width: "85%" }} forForm />
            {userDetails?.first_login && (
              <p
                className="user-create-password-skip-text"
                onClick={() => navigate("/")}
              >
                Skip
              </p>
            )}
          </div>
        </form>
      </div>
    </AuthLayout>
  );
};

export default CreatePassword;
